import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Lock, Mail } from 'lucide-react';
interface LoginPageProps {
  onLogin: (email: string, password: string) => void;
}
export function LoginPage({
  onLogin
}: LoginPageProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      onLogin(email, password);
      setIsLoading(false);
    }, 500);
  };
  return <div className="min-h-screen w-full flex items-center justify-center bg-background p-4" data-id="element-339">
      <div className="w-full max-w-md" data-id="element-340">
        <div className="text-center mb-8" data-id="element-341">
          <div className="inline-flex mb-6" data-id="element-342">
            
          </div>
          <h1 className="text-3xl font-bold text-foreground mb-2" data-id="element-343">
            Speedscaling CRM
          </h1>
          <p className="text-muted-foreground" data-id="element-344">Willkommen zurück</p>
        </div>

        <Card data-id="element-345">
          <CardHeader data-id="element-346">
            <CardTitle data-id="element-347">Anmelden</CardTitle>
            <CardDescription data-id="element-348">
              Demo-Login: Beliebige E-Mail und Passwort eingeben
            </CardDescription>
          </CardHeader>
          <CardContent data-id="element-349">
            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-350">
              <div className="space-y-2" data-id="element-351">
                <Label htmlFor="email" data-id="element-352">E-Mail</Label>
                <div className="relative" data-id="element-353">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" data-id="element-354" />
                  <Input id="email" type="email" placeholder="name@beispiel.de" value={email} onChange={e => setEmail(e.target.value)} className="pl-10" required data-id="element-355" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-356">
                <Label htmlFor="password" data-id="element-357">Passwort</Label>
                <div className="relative" data-id="element-358">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" data-id="element-359" />
                  <Input id="password" type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} className="pl-10" required data-id="element-360" />
                </div>
              </div>

              <Button type="submit" className="w-full" disabled={isLoading} data-id="element-361">
                {isLoading ? 'Wird angemeldet...' : 'Anmelden'}
              </Button>
            </form>

            <div className="mt-6 p-4 rounded-lg bg-[#f88d3e]/10 border border-[#f88d3e]/20" data-id="element-362">
              <p className="text-sm font-medium mb-2 text-[#f88d3e]" data-id="element-363">
                Demo-Hinweis:
              </p>
              <p className="text-xs text-muted-foreground" data-id="element-364">
                Dies ist eine Demo-Anwendung. Sie können sich mit beliebigen
                Anmeldedaten einloggen, um das CRM-System zu erkunden.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}